<kendo-dialog [minWidth]="250" (close)="onClick_Close('Cancel')" [width]="450">
  <kendo-dialog-titlebar>
    <div style="font-size: 18px; line-height: 1.3em;">
      <!--<img src="../../../../assets/images/Customer.png" alt="Customer" style="padding-right: 5px;">-->
      Create / Update Item Attribute Value
    </div>
  </kendo-dialog-titlebar>
  <div style="margin-top:15px;" #container id="container"></div>
  <form [formGroup]="itemAttributeValueForm">
 
        <input hidden="true" class="form-control" formControlName="itemID"
               [ngClass]="{ 'is-invalid': submitted && f.itemID.errors }" />
   
    <kendo-formfield>
      <kendo-label for="itemAttributeID" class="font-weight-bold" text="* Item Attribute"></kendo-label>
      <span class="k-textbox" style="width: 100%;">
        <ng-select id="itemAttributeID" class="noarrow" [multiple]="false" [selectOnTab]="true" appendTo="body" 
                   [notFoundText]="'Please start typing to search'" formControlName="itemAttributeID" [ngClass]="{
              'borderless': true,
              'is-invalid': submitted && f.itemAttributeID.errors,
              'w-100': true}" [searchable]="true" placeholder="Select an Item Attribute"
                   (search)="search($event, filters.ItemAttribute)" (change)="
              onSelectBoxChanged(
                  $event,
                  'itemAttribute',
                  itemAttributes)">
          <ng-option *ngFor="let item of itemAttributes" [value]="item.id">
            {{ item.name }}
          </ng-option>
        </ng-select>
        <kendo-textbox-separator></kendo-textbox-separator>
        <button kendoButton type="button" look="clear" (click)="onLookup_ItemAttribute()" icon="search"></button>
      </span>
      <kendo-formerror>Item Attribute is required</kendo-formerror>
    </kendo-formfield>

      <kendo-formfield *ngIf="attributeIsString">
        <kendo-label for="value" class="font-weight-bold" text="* Value"></kendo-label>
        <kendo-textbox class="form-control" formControlName="value" placeholder="Enter a Value" [clearButton]="true">
        </kendo-textbox>
        <kendo-formerror>Value required!</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="attributeIsDate">
        <kendo-label for="value" class="font-weight-bold" text="* Value"></kendo-label>
        <kendo-datepicker class="form-control" formControlName="value" placeholder="Enter a Value"
                          [(value)]="value">
        </kendo-datepicker>
        <kendo-formerror>Value required!</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="attributeIsNumber">
        <kendo-label for="value" class="font-weight-bold" text="* Value"></kendo-label>
        <kendo-numerictextbox class="form-control" type="number" formControlName="value" [decimals]="5"
                              placeholder="Enter a Value" [format]="'n5'" [min]="-99999999999999"  [max]="99999999999999">
        </kendo-numerictextbox>
        <kendo-formerror>Value required!</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield *ngIf="attributeIsCheckBox">
        <kendo-label for="value" class="font-weight-bold" text="* Value"></kendo-label>
        <input class="form-control" type="checkbox" formControlName="value" />
        <kendo-formerror>Value required!</kendo-formerror>
      </kendo-formfield>   
  </form>
  <kendo-dialog-actions>
    <button kendoButton (click)="onClick_Close('Cancel')"><span class="k-icon k-i-cancel"></span>Cancel</button>
    <button kendoButton *ngIf="isAdmin" (click)="onClick_Save()" primary="true" class="btn btn-primary"><span class="k-icon k-i-save"></span>Save</button>
  </kendo-dialog-actions>
</kendo-dialog>
